import { Grid } from "@material-ui/core";
import useCustomState from "../../hooks/State";
import WaterTank from "../WaterTank/WaterTank";
import DeviceAbstract from "./DeviceAbstract";

const LiveShow = ({ deviceInfo, changeTab, data }) => {
  const abstractStyle = {
    display: "flex",
    padding: "10px 24px",
    flexDirection: "column",
  };
  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={6} style={abstractStyle}>
        <DeviceAbstract info={deviceInfo} changeTab={changeTab} data={data} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={6}>
        <WaterTank data={data} info={deviceInfo} />
      </Grid>
    </>
  );
};
export default LiveShow;
